import { render, staticRenderFns } from "./HistoryTemplates.vue?vue&type=template&id=0fabc5dd&scoped=true"
import script from "./HistoryTemplates.vue?vue&type=script&lang=js"
export * from "./HistoryTemplates.vue?vue&type=script&lang=js"
import style0 from "./HistoryTemplates.vue?vue&type=style&index=0&id=0fabc5dd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabc5dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fabc5dd')) {
      api.createRecord('0fabc5dd', component.options)
    } else {
      api.reload('0fabc5dd', component.options)
    }
    module.hot.accept("./HistoryTemplates.vue?vue&type=template&id=0fabc5dd&scoped=true", function () {
      api.rerender('0fabc5dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/sendApproval/HistoryTemplates.vue"
export default component.exports